var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.461.932C4.301.932.931 4.3.931 8.46s3.37 7.53 7.53 7.53 7.53-3.37 7.53-7.53S12.62.931 8.46.931ZM2.814 8.46a5.652 5.652 0 0 1 5.647-5.647 5.59 5.59 0 0 1 3.266 1.054l-7.859 7.859A5.59 5.59 0 0 1 2.814 8.46Zm5.647 5.647a5.59 5.59 0 0 1-3.266-1.054l7.86-7.859a5.59 5.59 0 0 1 1.053 3.266 5.64 5.64 0 0 1-5.647 5.647Z",
    fill: "#5B5C5C"
  })));
};
export default SvgCancel;